<template>
  <div>
    <section class="d-flex justify-content-between align-items-center">
      <div>
        <b-button
          variant="warning"
          @click="downloadPdf"
        >
          {{ $t('contract.download_pdf') }}
        </b-button>
      </div>
      <div class="d-flex">
        <b-button
          v-if="GET_USER_PERMISSIONS.includes('admin') && !GET_ONE_CONTRACT.old"
          variant="success"
          class="mr-1"
          @click="makeContractPaid"
        >
          Оплачен
        </b-button>
        <b-button
          v-if="GET_USER_PERMISSIONS.includes('admin') && (!GET_ONE_CONTRACT.old || !GET_ONE_CONTRACT.sign_in)"
          variant="danger"
          class="mr-1"
          @click="terminateContract"
        >
          {{ $t('contract.terminate_contract') }}
        </b-button>
        <br>
        <b-button
          v-if="GET_USER_PERMISSIONS.includes('admin') && (!GET_ONE_CONTRACT.old || !GET_ONE_CONTRACT.sign_in)"
          class="mr-1"
          variant="danger"
          @click="cancelContract"
        >
          Аннулировать договор
        </b-button>
      </div>
    </section>
    <section>
      <iframe
        class="w-100 mt-1"
        style="min-height: 600px"
        :src="GET_ONE_CONTRACT.file"
        :alt="$t('administration.documents')"
      />
    </section>
  </div>
</template>

<script>
import {
  BButton,
  // BImg,
} from 'bootstrap-vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import download from '@/mixins/download'
import flatStatuses from '@/mixins/flat_statuses'

export default {
  components: {
    BButton,
    // BImg,
  },
  mixins: [download, flatStatuses],
  props: {
    url: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('contracts', ['GET_ONE_CONTRACT']),
    ...mapGetters('knowledgeBase', ['GET_FLAT_STATUSES']),
    ...mapGetters('users', ['GET_USER_PERMISSIONS']),
    getActualFile() {
      if (this.GET_ONE_CONTRACT.is_signed) {
        return this.GET_ONE_CONTRACT.files
      }
      return this.GET_ONE_CONTRACT.file
    },
  },
  mounted() {
    this.FETCH_ONE_CONTRACT(this.$route.params.id).then(() => {
      this.updateBreadCrumb()
    })
  },
  methods: {
    ...mapActions('contracts', ['FETCH_ONE_CONTRACT', 'EDIT_CONTRACT']),
    ...mapActions('flats', ['EDIT_FLAT']),
    ...mapMutations('breadcrumb', ['UPDATE_BREADCRUMB']),
    updateBreadCrumb() {
      const [first, second] = this.$_removeObjectConnection(this.$route.meta.breadcrumb)
      second.text = this.GET_ONE_CONTRACT.contract_number
      console.log([first, second])
      this.UPDATE_BREADCRUMB([first, second])
    },
    getUrlTAG() {
      const url = this.url.split('.')
      const format = url[url.length - 1]
      const images = ['png', 'jpeg', 'jpg', 'svg']
      if (format && format.toLowerCase() === 'pdf') return 'iframe'
      if (format && images.includes(format.toLowerCase())) return 'b-img'
      return format
    },
    downloadPdf() {
      // this.$_downloadInterval(this.GET_ONE_CONTRACT.files)
      if (this.GET_ONE_CONTRACT.is_signed) {
        this.$_downloadInterval(this.GET_ONE_CONTRACT.files)
      } else {
        this.$_downloadBlob(this.GET_ONE_CONTRACT.file)
      }
      // this.$_downloadMultipleFiles(this.GET_ONE_CONTRACT.files)
      // })
    },
    cancelContract() {
      this.EDIT_CONTRACT({ id: this.$route.params.id, is_active: false }).then(() => {
        this.EDIT_FLAT({ id: this.GET_ONE_CONTRACT.flat, current_status: this.flat_statuses.available })
        this.$router.push({ name: 'unsigned-contracts' })
      })
    },
    terminateContract() {
      this.cancelContract()
    },
    makeContractPaid() {
      this.$router.push({ name: 'finance' })
      // this.EDIT_CONTRACT({ id: this.$route.params.id, payment_status: 1 }).then(() => {
      //   this.$_successToast(this.$t('generals.updated'))
      //   this.$router.push({ name: 'unsigned-contracts' })
      // }).catch(() => {
      //   this.$_errorToast(this.$t('generals.error'))
      // })
    },
  },
}
</script>

<style>
</style>
